import React from 'react';
import { Tabs, Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import PersistentDrawerLeft from '../../reusable/admin/Main';
import AllEmployeeDetails from './AllEmployeeDetails';
import AttendanceList from './AttendanceList';
import Salary from './Salary';

const { Title } = Typography;
const { TabPane } = Tabs;

const Wrapper = styled.div`
  padding: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const StyledTitle = styled(Title)`
  && {
    margin: 0;
    font-weight: 600;
    font-size: 26px;
  }
`;

const StyledTabs = styled(Tabs)`
  && {
    .ant-tabs-nav {
      margin-bottom: 16px;
    }
    .ant-tabs-tab {
      font-weight: 500;
      font-size: 16px;
      color: #5c5c5c;
      transition: color 0.3s ease;
    }
    .ant-tabs-tab:hover {
      color: #1890ff;
    }
    .ant-tabs-tab.ant-tabs-tab-active {
      color: #1890ff;
      font-weight: 600;
      border-bottom: 2px solid #1890ff;
    }
    .ant-tabs-ink-bar {
      background-color: #1890ff;
    }
  }
`;

const ReportFilters = () => {
  return (
    <PersistentDrawerLeft>
      <Wrapper>
        <Header>
          <StyledTitle level={3}>
            <FileTextOutlined style={{ marginRight: 8 }} />
            Reports
          </StyledTitle>
        </Header>

        <StyledTabs defaultActiveKey="1">
          <TabPane tab="All Employee Details" key="1">
            <AllEmployeeDetails />
          </TabPane>
          <TabPane tab="Attendance List" key="2">
            <AttendanceList />
          </TabPane>
          <TabPane tab="Salary" key="3">
            <Salary />
          </TabPane>
        </StyledTabs>
      </Wrapper>
    </PersistentDrawerLeft>
  );
};

export default ReportFilters;
